import { PRODUCT_MANAGEMENT_TYPE, PRODUCT_OPTION_STATUS } from '../../../../constants/service/app/productConstants';
import { ProductOption } from '../../../../types/product';

export const isProductOptionAvailableForTodayDelivery = (item: ProductOption): boolean => {
  const isNotEnterType = item.productManagementType !== PRODUCT_MANAGEMENT_TYPE.ENTER;
  const isActive = item.status === PRODUCT_OPTION_STATUS.ACTIVE;
  return isNotEnterType && isActive;
};
export const isProductOptionValidForGift = (item: ProductOption): boolean =>
  Boolean(item.isGift) && item.status === PRODUCT_OPTION_STATUS.ACTIVE;

export const isProductOptionValidForTodayDelivery = (item: ProductOption): boolean =>
  isProductOptionAvailableForTodayDelivery(item);
